module.exports = __webpack_public_path__ + "static/media/  (145).a449a7c8.jpg";